import React, { Component } from 'react';
import '../css/formats.css';
import $ from "jquery";

class CancelPaymentModal extends Component {
    closeModal = () => {
        const { isMassive = false, resetPaymentsToCancel } = this.props;
        $('#cancelDateModal').modal('hide');
        if (isMassive) {
            setTimeout(() => {
                resetPaymentsToCancel();
            }, 500);
        }
    }

    render() {
        const {
            cancelCurrentDate,
            changeCancelDate,
            continueAction,

            //#region Cancelación de pagos masiva
            isMassive = false,
            documents = [],
            cancelMode = 'global',
            changeCancelMode,
            documentDates = {},
            changeDocumentDate
            //#endregion Cancelación de pagos masiva
        } = this.props;

        return (
            <div>
                <div className='modal fade bd-example-modal-lg modal-open pt-5 mt-5' id="cancelDateModal" data-keyboard="false" tabIndex="-1" aria-labelledby="collectModalLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-lg modal-open modalOrder" role="document">
                        <div className="modal-content" id="cancelDateModal">
                            <div className="modal-header text-white"
                                style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">
                                    Fecha de cancelación
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container">
                                    <div className="row justify-content-around">
                                        <div className="col-sm col">
                                            {/* NORMAL */}
                                            {
                                                !isMassive && (
                                                    <>
                                                        <div className='mb-4 font-weight-bold'>
                                                            La fecha del documento no corresponde a la fecha actual.
                                                            <br />
                                                            Seleccione la fecha para cancelar el documento.
                                                        </div>

                                                        {/*Fecha del Documento*/}
                                                        <div className="input-group mb-3 d-flex align-items-center">
                                                            <input
                                                                className='mr-2'
                                                                type='radio'
                                                                id='taxDate'
                                                                name='cancelDate'
                                                                onChange={() => changeCancelDate(false)}
                                                                checked={!cancelCurrentDate}
                                                            />

                                                            <label className='mb-0' htmlFor="taxDate">
                                                                Fecha del documento
                                                            </label>
                                                        </div>

                                                        {/*Fecha Actual*/}
                                                        <div className="input-group mb-3 d-flex align-items-center">
                                                            <input
                                                                className='mr-2'
                                                                type='radio'
                                                                id='todayDate'
                                                                name='cancelDate'
                                                                onChange={() => changeCancelDate(true)}
                                                                checked={cancelCurrentDate}
                                                            />

                                                            <label className='mb-0' htmlFor="todayDate">
                                                                Fecha actual
                                                            </label>
                                                        </div>
                                                    </>
                                                )
                                            }

                                            {/* MASIVO */}
                                            {
                                                isMassive && (
                                                    <>
                                                        <div className='mb-4 font-weight-bold'>
                                                            Seleccione cómo desea cancelar los pagos.
                                                        </div>

                                                        {/*Modo global*/}
                                                        <div className="input-group mb-3 d-flex align-items-center">
                                                            <input
                                                                className='mr-2'
                                                                type='radio'
                                                                id='globalMode'
                                                                name='cancelMode'
                                                                checked={cancelMode === 'global'}
                                                                onChange={() => changeCancelMode('global')}
                                                            />

                                                            <label className='mb-0' htmlFor="globalMode">
                                                                Aplicar misma fecha a todos los pagos
                                                            </label>
                                                        </div>

                                                        {/*Modo individual*/}
                                                        <div className="input-group mb-4 d-flex align-items-center">
                                                            <input
                                                                className='mr-2'
                                                                type='radio'
                                                                id='individualMode'
                                                                name='cancelMode'
                                                                checked={cancelMode === 'individual'}
                                                                onChange={() => changeCancelMode('individual')}
                                                            />

                                                            <label className='mb-0' htmlFor="individualMode">
                                                                Seleccionar fecha por pago
                                                            </label>
                                                        </div>

                                                        {/* GLOBAL */}
                                                        {
                                                            cancelMode === 'global' && (
                                                                <>
                                                                    <div className='mb-4 font-weight-bold'>
                                                                        Seleccione la fecha a aplicar.
                                                                    </div>
                                                                    {/*Fecha del Documento*/}
                                                                    <div className="input-group mb-3 d-flex align-items-center">
                                                                        <input
                                                                            className='mr-2'
                                                                            type='radio'
                                                                            id='globalTaxDate'
                                                                            name='globalCancelDate'
                                                                            onChange={() => changeCancelDate(false)}
                                                                            checked={!cancelCurrentDate}
                                                                        />

                                                                        <label className='mb-0' htmlFor="globalTaxDate">
                                                                            Fecha del pago para todos
                                                                        </label>
                                                                    </div>

                                                                    {/*Fecha Actual*/}
                                                                    <div className="input-group mb-3 d-flex align-items-center">
                                                                        <input
                                                                            className='mr-2'
                                                                            type='radio'
                                                                            id='globalTodayDate'
                                                                            name='globalCancelDate'
                                                                            onChange={() => changeCancelDate(true)}
                                                                            checked={cancelCurrentDate}
                                                                        />

                                                                        <label className='mb-0' htmlFor="globalTodayDate">
                                                                            Fecha actual para todos
                                                                        </label>
                                                                    </div>
                                                                </>
                                                            )
                                                        }

                                                        {/* INDIVIDUAL */}
                                                        {
                                                            cancelMode === 'individual' && (
                                                                <>
                                                                    <div className='table-responsive' style={{ maxHeight: '400px', overflowY: 'auto' }} >
                                                                        <table className='table table-bordered table-sm'>
                                                                            <thead className='thead-dark'>
                                                                                <tr className='text-center'>
                                                                                    <th>Documento</th>
                                                                                    <th>Fecha del pago</th>
                                                                                    <th>Fecha actual</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    documents.map((doc, index) => {
                                                                                        const currentValue = documentDates?.[doc.DocEntry] ?? false;

                                                                                        return (
                                                                                            <tr key={index}>
                                                                                                <td className='text-center'>
                                                                                                    {doc.DocNum}
                                                                                                </td>
                                                                                                {/* Fecha del pago */}
                                                                                                <td className='text-center'>
                                                                                                    <input
                                                                                                        type='radio'
                                                                                                        id={`docDate_${doc.DocEntry}`}
                                                                                                        name={`cancelDate_${doc.DocEntry}`}
                                                                                                        checked={!currentValue}
                                                                                                        onChange={() => changeDocumentDate(doc.DocEntry, false)}
                                                                                                    />
                                                                                                </td>
                                                                                                {/* Fecha actual */}
                                                                                                <td className='text-center'>
                                                                                                    <input
                                                                                                        type='radio'
                                                                                                        id={`currentDate_${doc.DocEntry}`}
                                                                                                        name={`cancelDate_${doc.DocEntry}`}
                                                                                                        checked={currentValue}
                                                                                                        onChange={() => changeDocumentDate(doc.DocEntry, true)}
                                                                                                    />
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    })
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </>
                                                            )
                                                        }
                                                    </>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn botonCorrect"
                                    onClick={() => {
                                        this.closeModal();
                                        isMassive ? continueAction(13) : continueAction();
                                    }}
                                >
                                    Aceptar
                                </button>

                                <button
                                    type="button"
                                    className="btn botonCerrar text-white"
                                    onClick={this.closeModal}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CancelPaymentModal;